export const faqSchemaTypes = {
  Answer: "Answer",
  FAQPage: "FAQPage",
  Question: "Question",
} as const;
